import { cn } from '@packages/shared/src/utils/cn/cn';
import type { TooltipProps } from './TooltipProps';

const tipTopBottom =
  'before:border-l-color-transparent before:border-r-color-transparent before:scale-y-150 before:border-r-8 before:border-l-8';
const tipAside =
  'before:border-t-color-transparent before:border-b-color-transparent before:scale-x-150 before:border-t-8 before:border-b-8';
const tipTop = 'before:border-b-color-text-light before:-top-1 before:border-b-8';
const tipBottom = 'before:border-t-color-text-light before:-bottom-1 before:border-t-8';
const tipLeftAside = 'before:border-r-color-text-light before:-left-1 before:border-r-8';
const tipRightAside = 'before:border-l-color-text-light before:-right-1 before:border-l-8';
const tipRight = 'before:right-1';
const tipLeft = 'before:left-1';

const toolTipBottomRight = cn('mt-4', tipTop, tipLeft, tipTopBottom);
const toolTipBottomLeft = cn('mt-4', tipTop, tipRight, tipTopBottom);
const toolTipTopRight = cn('bottom-0 mb-4.5', tipBottom, tipLeft, tipTopBottom);
const toolTipTopLeft = cn('bottom-0 mb-4.5', tipBottom, tipRight, tipTopBottom);
const toolTipRight = cn('left-4 -mt-1', tipLeftAside, tipAside);
const toolTipLeft = cn('right-4 -mt-1', tipRightAside, tipAside);

export const toolTipStyles = {
  toolTipBottomRight,
  toolTipBottomLeft,
  toolTipTopRight,
  toolTipTopLeft,
  toolTipRight,
  toolTipLeft,
};

export const infoIconStyles = ({
  variant,
  positioningInfoIcon,
  positioningTooltip,
}: {
  variant?: 'inline' | 'default';
  positioningInfoIcon: TooltipProps['positioning'];
  positioningTooltip?: TooltipProps['positioning'];
}) =>
  [
    'text-size-h4 flex flex-col p-0.5',
    variant === 'inline' ? 'relative' : 'absolute',
    positioningInfoIcon === 'left' && 'top-1/2 left-1',
    positioningInfoIcon === 'right' && 'top-1/2 right-1',
    positioningInfoIcon === 'top-start' && 'top-1 left-1',
    positioningInfoIcon === 'top-end' && 'top-1 right-1',
    positioningInfoIcon === 'bottom-start' && 'bottom-1 left-1',
    positioningInfoIcon === 'bottom-end' && 'right-1 bottom-1',
    positioningTooltip && ['right', 'top-end', 'bottom-end'].includes(positioningTooltip)
      ? 'items-end'
      : null,
  ]
    .join(' ')
    .trim();

export const wrapperStyles = ({
  variant,
  positioning,
}: {
  variant?: TooltipProps['variant'];
  positioning: TooltipProps['positioning'];
}) =>
  [
    variant === 'inline' ? 'inline-flex' : 'flex',
    positioning && ['top-start', 'bottom-start', 'left'].includes(positioning)
      ? 'flex-row-reverse'
      : null,
    'relative',
  ]
    .join(' ')
    .trim();

export const infoIconButtonStyles = (tooltipOpen: boolean) =>
  [
    'bg-color-info-light border-color-info-dark hover:bg-color-info! border-1 border-solid w-3 h-3 min-h-3',
    tooltipOpen ? 'shadow-lg' : null,
  ]
    .join(' ')
    .trim();

export const tooltipContainerStyles = (positioningTooltip?: TooltipProps['positioning']) =>
  [
    'z-tooltip text-size-body3 bg-color-text-light text-color-text-dark absolute m-0.5 w-[18.75rem] max-w-[70vw] rounded p-1 font-normal shadow-lg before:absolute',
    positioningTooltip === 'top-start' ? toolTipStyles.toolTipBottomRight : null,
    positioningTooltip === 'top-end' ? toolTipStyles.toolTipBottomLeft : null,
    positioningTooltip === 'left' ? toolTipStyles.toolTipRight : null,
    positioningTooltip === 'right' ? toolTipStyles.toolTipLeft : null,
    positioningTooltip === 'bottom-start' ? toolTipStyles.toolTipTopRight : null,
    positioningTooltip === 'bottom-end' ? toolTipStyles.toolTipTopLeft : null,
  ]
    .join(' ')
    .trim();
